import React, { useState, useEffect } from "react";
import Icon from "@nxsys/components/AppIconImage";
import {
  IconAttachmentPDF,
  IconAttachmentDOC,
  IconAttachmentCSV,
  IconAttachmentTXT,
  IconAttachmentXLS,
  IconAttachmentXLSX,
  IconAttachmentPPT,
  IconAttachmentZIP,
  IconAttachmentIMAGE,
  IconAttachmentOthers,
} from "@nxsys/assets/icons";
import { getFileNameFromUrl, getFileTypeFromUrl } from "@nxsys/utils";
import { StyledAttachment } from "./index.styled";

type AppAttachmentProps = {
  urlFile?: string;
  title?: string;
  className?: string;
};

const AppAttachment: React.FC<AppAttachmentProps> = ({ urlFile, title, className }: AppAttachmentProps) => {
  const [fileInfo, setFileInfo] = useState<{
    url: string;
    name: string;
    type: string;
  } | null>(null);

  useEffect(() => {
    if (urlFile) {
      const name = getFileNameFromUrl(urlFile);
      const type = getFileTypeFromUrl(urlFile);
      setFileInfo({ url: urlFile, name, type });
    }
  }, [urlFile]);

  const formatTypeToIcon = (type: string | undefined) => {
    switch (type) {
      case "application/pdf":
        return <Icon src={IconAttachmentPDF} alt="pdf" />;
      case "application/msword":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        return <Icon src={IconAttachmentDOC} alt="doc" />;
      case "text/csv":
      case "application/csv":
        return <Icon src={IconAttachmentCSV} alt="csv" />;
      case "text/plain":
        return <Icon src={IconAttachmentTXT} alt="txt" />;
      case "application/vnd.ms-excel":
        return <Icon src={IconAttachmentXLS} alt="xls" />;
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        return <Icon src={IconAttachmentXLSX} alt="xlsx" />;
      case "application/vnd.ms-powerpoint":
      case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        return <Icon src={IconAttachmentPPT} alt="ppt" />;
      case "application/zip":
      case "application/x-zip-compressed":
        return <Icon src={IconAttachmentZIP} alt="zip" />;
      default:
        if (type && type.includes("image")) {
          return <Icon src={IconAttachmentIMAGE} alt="image" />;
        }
        if (type && type.includes("excel")) {
           return <Icon src={IconAttachmentXLS} alt="xls" />;
        }
        return <Icon src={IconAttachmentOthers} alt="other" />;
    }
  };
  return (
    <StyledAttachment className={className}>
      {formatTypeToIcon(fileInfo?.type)}
      {title || fileInfo?.name || "No Attachment"}
    </StyledAttachment>
);
}
export default AppAttachment;
